import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { contactInfo } from '../data/mock';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Accueil' },
    { path: '/about', label: 'À propos' },
    { path: '/services', label: 'Services' },
    { path: '/tarifs', label: 'Tarifs' },
    { path: '/testimonials', label: 'Témoignages' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <header className="bg-white/95 backdrop-blur-sm border-b border-gray-200 fixed w-full top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          
          {/* Logo */}
          <Link to="/" className="heading-2 text-gradient hover:scale-105 transition-transform">
            PodioSoins+
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`nav-link ${
                  location.pathname === link.path ? 'nav-active' : ''
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Desktop CTA Buttons */}
          <div className="hidden lg:flex items-center space-x-4">
            <a 
              href={`tel:${contactInfo.phone}`} 
              className="btn-secondary"
            >
              <Phone size={16} />
              <span className="button-text">Appeler</span>
            </a>
            <Link to="/contact" className="btn-primary">
              Rendez-vous
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? (
              <X size={24} className="text-gray-600" />
            ) : (
              <Menu size={24} className="text-gray-600" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`nav-link ${
                    location.pathname === link.path ? 'nav-active' : ''
                  }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {link.label}
                </Link>
              ))}
            </nav>
            <div className="flex flex-col space-y-3 mt-6">
              <a
                href={`tel:${contactInfo.phone}`}
                className="btn-secondary justify-center"
                onClick={() => setIsMenuOpen(false)}
              >
                <Phone size={16} />
                <span className="button-text">Appeler</span>
              </a>
              <Link 
                to="/contact" 
                className="btn-primary justify-center"
                onClick={() => setIsMenuOpen(false)}
              >
                Prendre rendez-vous
              </Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;